import {useEffect, useState} from 'react';
import {LocalStorage} from "../../../utils/LocalStorage";

// Lo mismo que relee el banner de conexiones caídas (`DisconnectedCredentialsBanner`): el chequeo
// periódico (`useAgencyStatusRefresh`) escribe en LocalStorage después de que la pantalla ya pintó.
const REFRESH_INTERVAL_MS = 5000;

/**
 * Cuántos accesos de la agencia hay que reconectar: la señal del «N por reconectar» del desplegable
 * de la agencia y del punto rojo de Conexiones › Plataformas en la 2.1 (tanda «Agencia 2.1», D3/D4).
 *
 * Sale del MISMO estado que el banner global, sin pedido propio: el banner, el desplegable y el
 * punto no pueden contestar distinto. 0 = nada que reconectar (o el estado es de otra sesión).
 */
export function useAccessAttention() {
    const [count, setCount] = useState(() => LocalStorage.fetchDisconnectedCredentialsCount());

    useEffect(() => {
        const read = () => setCount(LocalStorage.fetchDisconnectedCredentialsCount());
        read();
        const interval = setInterval(read, REFRESH_INTERVAL_MS);
        return () => clearInterval(interval);
    }, []);

    return count;
}
